import React from "react";
import ListGroup from "react-bootstrap/ListGroup";
import Badge from "react-bootstrap/Badge";
import Button from "react-bootstrap/Button";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useTranslation } from "../hooks/useTranslation";

export const SIDEBAR_WIDTH = 280;
export const SIDEBAR_COLLAPSED = 48;

export default function ModuleSidebar({
  modules = [],
  activeModuleId,
  collapsed,
  onToggleCollapsed,
  onSelectModule,
  leftOffset = 240,      // Platz für eure GlobalNav
  zIndex = 100,
  transitionMs = 220,
}) {
  const { t } = useTranslation();
  const asideWidth = collapsed ? SIDEBAR_COLLAPSED : SIDEBAR_WIDTH;

  return (
    <aside
      className="fintogo-module-sidebar"
      style={{
        position: "fixed",
        left: leftOffset,
        top: 0,
        height: "100vh",
        width: asideWidth,
        background: "var(--bg-card)",
        borderRight: "1px solid var(--border-color)",
        overflowX: "hidden",
        overflowY: "auto",
        transition: `width ${transitionMs}ms ease`,
        zIndex,
      }}
    >
      <div className="p-3">
        <div className="d-flex justify-content-between align-items-center mb-3">
          {!collapsed && <h5 className="mb-0">{t.modules.title}</h5>}
          <Button
            variant="light"
            size="sm"
            onClick={onToggleCollapsed}
            aria-label={collapsed ? "Sidebar öffnen" : "Sidebar schließen"}
          >
            {collapsed ? <ChevronRight size={18} /> : <ChevronLeft size={18} />}
          </Button>
        </div>

        {!collapsed ? (
          <ListGroup variant="flush">
            {modules.map((mod) => (
              <ListGroup.Item
                key={mod.id}
                action
                active={mod.id === activeModuleId}
                onClick={() => onSelectModule(mod.id)}
                style={{ cursor: "pointer", borderRadius: 8, marginBottom: 4 }}
              >
                <div className="d-flex justify-content-between align-items-start">
                  <div className="flex-grow-1" style={{ minWidth: 0 }}>
                    <div className="fw-semibold text-truncate">{mod.title}</div>
                    <small className="text-muted">
                      {mod.year_level}. {t.modules.class} • {t.modules.semester} {mod.semester}
                    </small>
                  </div>

                  {/* Badge: Kontrast fix, siehe Punkt 2 */}
                  <Badge bg="light" text="dark">
                    {mod.order_index || 0}
                  </Badge>
                </div>
              </ListGroup.Item>
            ))}

            {modules.length === 0 && (
              <div className="text-muted small px-2 py-2">{t.modules.noModules}</div>
            )}
          </ListGroup>
        ) : (
          <div className="d-flex flex-column align-items-center gap-2 pb-3">
            {modules.map((mod) => {
              const isActive = mod.id === activeModuleId;
              return (
                <button
                  key={mod.id}
                  type="button"
                  onClick={() => onSelectModule(mod.id)}
                  title={mod.title}
                  aria-label={mod.title}
                  style={{
                    width: 36,
                    height: 36,
                    borderRadius: 10,
                    border: `1px solid var(--border-color)`,
                    background: isActive ? "rgba(30,136,229,0.18)" : "transparent",
                    color: "var(--text-primary)",
                    display: "grid",
                    placeItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <span style={{ fontSize: 12, fontWeight: 700, lineHeight: 1 }}>
                    {mod.order_index || 0}
                  </span>
                </button>
              );
            })}
          </div>
        )}
      </div>
    </aside>
  );
}
